<script>
import { _ } from 'svelte-intl';

export let type = 'success';
export let message;
export let description;
</script>

<div class="confirmationContainer">
  {#if type == 'success'}
    <img src="/images/check.svg" alt="success icon" />
  {:else if type === 'warning'}
    <img src="/images/cross.svg" alt="warning icon" />
  {/if}
  {#if message}
    <p class="textFirst">{@html message}</p>
  {/if}
  {#if description}
    <p class="textSecond">{@html description}</p>
  {/if}
</div>

<style>
.confirmationContainer {
  background-color: #ffffff;
  max-width: 700px;
  margin: 8rem auto 5rem;
  text-align: center;
  padding: 6rem;
  transform: scale(0);
  animation: animConfirmation 0.5s forwards;
}

@media(max-width: 1023px) {
  .confirmationContainer {
    margin: 5rem 0 0;
    padding: 6rem 2rem;
    max-width: 100%;
  }
}

.confirmationContainer img {
  width: 100px;
}

.confirmationContainer .textFirst {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.confirmationContainer .textSecond {
  font-size: 2rem;
  font-style: italic;
  margin-top: 1rem;
  margin-bottom: 0;
}

@keyframes animConfirmation {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media(max-width: 767px) {
  .confirmationContainer .textFirst {
    font-size: 2.6rem;
  }
  
  .confirmationContainer .textSecond {
    font-size: 1.6rem;
  }
}
</style>